import { useSyncExternalStore } from 'react';

// Module-scoped shared state so every consumer of useCartSidebar sees
// the same `isOpen` value — letting Header, FloatingCart, and the new
// CondensedHeader all toggle the same sidebar.
let isOpen = false;
const listeners = new Set();

const setOpen = (next) => {
  const value = typeof next === 'function' ? next(isOpen) : next;
  if (value === isOpen) return;
  isOpen = value;
  listeners.forEach((fn) => fn());
};

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => isOpen;

const useCartSidebar = () => {
  const currentOpen = useSyncExternalStore(subscribe, getSnapshot);
  return {
    isOpen: currentOpen,
    openSidebar: () => setOpen(true),
    closeSidebar: () => setOpen(false),
    toggleSidebar: () => setOpen((v) => !v),
  };
};

export default useCartSidebar;
